"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoticeFrequencyEnum = void 0;
/**
 * Частота уведомлений
 */
var NoticeFrequencyEnum;
(function (NoticeFrequencyEnum) {
  /** Никогда не уведомлять */
  NoticeFrequencyEnum[NoticeFrequencyEnum["none"] = 0] = "none";
  /** Всегда уведомлять */
  NoticeFrequencyEnum[NoticeFrequencyEnum["immediately"] = 1] = "immediately";
  /** Уведомлять не чаще одного раза в день */
  NoticeFrequencyEnum[NoticeFrequencyEnum["daily_digest"] = 2] = "daily_digest";
})(NoticeFrequencyEnum = exports.NoticeFrequencyEnum || (exports.NoticeFrequencyEnum = {}));
